import type { AnchorProfile } from '@/types'

export function canAnchorHandleIncomingCall(anchor: AnchorProfile | null | undefined) {
  return anchor?.account_status === 0
}

export function canAnchorConfigureReceiving(anchor: AnchorProfile | null | undefined) {
  return anchor?.account_status === 0
}
